import * as landlordTableColumns from "../actions/landlord-table-columns";
import { IColumnDefinition } from "../../common/models/column-definition";

export interface State {
  availableColumns: IColumnDefinition[];
  error: string,
  loading: boolean,
}

export const INITIAL_STATE: State = {
  availableColumns: [],
  error: null,
  loading: false,
}

export function reducer(state: State = INITIAL_STATE, action: landlordTableColumns.Actions): State {
  switch (action.type) {
    case landlordTableColumns.LOAD:
      {
        return {
          ...state,
          loading: true
        };
      }
    case landlordTableColumns.LOAD_COMPLETE:
      {
        return {
          ...state,
          availableColumns: action.payload,
          error: null,
          loading: false
        };
      }

    case landlordTableColumns.LOAD_ERROR:
      {
        var errorMessage = null;
        if (action.payload.hasOwnProperty('message')) {
          errorMessage = action.payload.message;
        }
        return {
          ...state,
          error: errorMessage,
          loading: false,
          availableColumns: undefined,
        };
      }
    default:
      {
        return state;
      }
  }

}

